import { render, staticRenderFns } from "./AnimatedStarMap.vue?vue&type=template&id=11b70b88&scoped=true&"
import script from "./AnimatedStarMap.vue?vue&type=script&lang=ts&"
export * from "./AnimatedStarMap.vue?vue&type=script&lang=ts&"
import style0 from "./AnimatedStarMap.vue?vue&type=style&index=0&id=11b70b88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b70b88",
  null
  
)

export default component.exports